import "@smoothie-framework/ui/styles";
import "./styles.css";
import { render } from "@smoothie-framework/ui";
import { App } from "./components/app";
import { initializeHeaderScroll } from "./components/header";

const root = document.querySelector<HTMLDivElement>("#app");

if (!root) {
  throw new Error("Missing #app element");
}

render(() => <App />, root, { preserveExistingContent: false });
window.requestAnimationFrame(initializeHeaderScroll);
